import { Pipe, PipeTransform } from '@angular/core'
import { Marker } from '@app-domains/google-maps/types/marker'
import { AlgoliaDealer } from '@app-types/dealer.types'

@Pipe({
    name: 'transformDealer',
})
export class TransformDealerPipe implements PipeTransform {

    transform(dealers: AlgoliaDealer[]): Marker[] {
        return dealers.map((dealer): Marker => ({
            objectID: dealer.objectID,
            // eslint-disable-next-line no-underscore-dangle
            lat: dealer._geoloc.lat,
            // eslint-disable-next-line no-underscore-dangle
            lng: dealer._geoloc.lng,
            name: dealer.name,
            website: dealer.website,
            street: dealer.address,
            postalCode: dealer.postal_code,
            city: dealer.city,
            icon: this.getDealerIcon(dealer.types),
            brands: dealer.brands,
            country: dealer.country,
            country_code: dealer.country_code,
        }))
    }

    private getDealerIcon(types: string[]): 'dealer' | 'dealer-shop' | 'webshop' {
        if (types.includes('dealer') && types.includes('webshop')) {
            return 'dealer-shop'
        }

        if (types.includes('dealer')) {
            return 'dealer'
        }

        if (types.includes('webshop')) {
            return 'webshop'
        }

        return 'dealer'
    }
}
